
.notScheduledCharts {
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}